import _styled, { css as _css, default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7 } from "styled-components";
import React from "react";
type Props = {
  image?: string;
  title: string;
  description?: string;
  selected?: boolean;
  onSelect?: () => void;
};
const cardStyle = /*#__PURE__*/_css(["", ""], {
  "display": "flex",
  "cursor": "pointer",
  "gap": "var(--spacing-md)",
  "borderRadius": "4px",
  "padding": "var(--spacing-sm)",
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out"
});
const selectedStyle = /*#__PURE__*/_css(["", ""], {
  "--tw-bg-opacity": "1 !important",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity)) !important"
});
const defaultStyle = /*#__PURE__*/_css(["", ""], {
  "backgroundColor": "var(--bg-transparent-10) !important",
  "&:hover": {
    "backgroundColor": "var(--bg-transparent-20) !important"
  }
});
export function ConfiguratorOptionCard(props: Props) {
  const {
    image,
    title,
    description,
    selected = false,
    onSelect
  } = props;
  return <_StyledButton type="button" aria-pressed={selected} onClick={onSelect} $_css2={[cardStyle, selected ? selectedStyle : defaultStyle]}>
      <_StyledDiv>
        {image && <_StyledImg src={image} alt={title} loading="lazy" />}
      </_StyledDiv>
      <_StyledDiv2>
        <_StyledSpan $_css3={[{
        "fontSize": "1.4rem",
        "lineHeight": "1.5",
        "letterSpacing": "0.014000000000000002rem",
        "fontWeight": "400",
        "color": "var(--text-primary)",
        "@media (min-width: 1024px)": {
          "fontSize": "1.4rem",
          "lineHeight": "1.5",
          "letterSpacing": "0.014000000000000002rem",
          "fontWeight": "400"
        }
      }, selected && {
        "--tw-text-opacity": "1",
        "color": "rgb(255 255 255 / var(--tw-text-opacity))"
      }]}>
          {title}
        </_StyledSpan>
        {description && <_StyledSpan2 $_css4={[{
        "textAlign": "left",
        "fontSize": "1.4rem",
        "lineHeight": "1.5",
        "letterSpacing": "0.014000000000000002rem",
        "fontWeight": "400",
        "color": "var(--text-transparent)"
      }, selected && {
        "--tw-text-opacity": "1",
        "color": "rgb(255 255 255 / var(--tw-text-opacity))"
      }]}>
            {description} <_StyledSpan3>Learn more</_StyledSpan3>
          </_StyledSpan2>}
      </_StyledDiv2>
    </_StyledButton>;
}
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-sf-y4m8z6-0"
})`${p => p.$_css2}`;
var _StyledDiv = _styled2("div").withConfig({
  componentId: "sc-sf-y4m8z6-1"
})({
  "height": "4.8rem",
  "width": "4.8rem",
  "flexShrink": "0",
  "overflow": "hidden",
  "borderRadius": "2px",
  "backgroundColor": "var(--bg-inverse)"
});
var _StyledImg = _styled3("img").withConfig({
  componentId: "sc-sf-y4m8z6-2"
})({
  "height": "100%",
  "width": "100%",
  "objectFit": "cover"
});
var _StyledDiv2 = _styled4("div").withConfig({
  componentId: "sc-sf-y4m8z6-3"
})({
  "display": "flex",
  "minWidth": "0",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "var(--spacing-xs)"
});
var _StyledSpan = _styled5("span").withConfig({
  componentId: "sc-sf-y4m8z6-4"
})`${p => p.$_css3}`;
var _StyledSpan2 = _styled6("span").withConfig({
  componentId: "sc-sf-y4m8z6-5"
})`${p => p.$_css4}`;
var _StyledSpan3 = /*#__PURE__*/_styled7("span").withConfig({
  displayName: "configurator-option-card___StyledSpan3",
  componentId: "sc-1u8jk3o-0"
})({
  "textDecorationLine": "underline"
});